import { DEFAULT_LOCALE, isAppLocale, type AppLocale } from './locales';

/**
 * Tenant inspect config (`clivconfig` …/inspect/{tenantId}.json):
 * - `enable-display-languages`: false/absent → English only (default).
 * - `enable-display-languages`: true → use `display-locales` (or built-in default list).
 */
export const ENGLISH_ONLY_DISPLAY_LOCALES: readonly AppLocale[] = ['en'];

/** Used when translations are enabled but `display-locales` is omitted. */
export const DEFAULT_TRANSLATION_DISPLAY_LOCALES: readonly AppLocale[] = ['en', 'zh-Hans', 'tr'];

export function isDisplayLanguagesEnabled(translationsEnabled: boolean | undefined): boolean {
  return translationsEnabled === true;
}

export function parseDisplayLocales(configured: string[] | undefined): AppLocale[] {
  if (!configured || configured.length === 0) {
    return [...DEFAULT_TRANSLATION_DISPLAY_LOCALES];
  }
  const unique: AppLocale[] = [];
  for (const value of configured) {
    if (!isAppLocale(value) || unique.includes(value)) {
      continue;
    }
    unique.push(value);
  }
  if (unique.length === 0) {
    return [...DEFAULT_TRANSLATION_DISPLAY_LOCALES];
  }
  if (!unique.includes(DEFAULT_LOCALE)) {
    return [DEFAULT_LOCALE, ...unique];
  }
  return unique;
}

export function resolveEnabledDisplayLocales(
  translationsEnabled: boolean | undefined,
  configuredLocales: string[] | undefined
): AppLocale[] {
  if (!isDisplayLanguagesEnabled(translationsEnabled)) {
    return [...ENGLISH_ONLY_DISPLAY_LOCALES];
  }
  return parseDisplayLocales(configuredLocales);
}

export function resolveLocaleWithinEnabled(
  preferred: AppLocale | null,
  enabledLocales: readonly AppLocale[]
): AppLocale {
  if (preferred && enabledLocales.includes(preferred)) {
    return preferred;
  }
  if (enabledLocales.includes(DEFAULT_LOCALE)) {
    return DEFAULT_LOCALE;
  }
  return enabledLocales[0] ?? DEFAULT_LOCALE;
}
